import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import getWithAuth from "../../context/getWithAuth";
import Loader from "../../components/loader";
import ToSModal from "../../components/tosModal";
import UserContext from "../../context/userContext";
import LocalLoaderLight from "../../components/localLoaderLight";
import TeacherSummaryCard from "./teacherSummaryCard";

function TeachingSummary(props) {
    const [teachingOverviewData, setTeachingOverviewData] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    });
    const [isLoading, setIsLoading] = useState(false);

    const user = useContext(UserContext);
    const navigate = useNavigate();

    const fetchTeacherOverview = async () => {
        if (user.userAttributes) {
            try {
                getWithAuth('/building/getTeachingOverview', user.userAttributes['custom:school'], {startDate: startDate, endDate: endDate})
                    .then(async r => {
                        setTeachingOverviewData(r);
                        setIsLoading(false);
                    })
            } catch (error) {
                console.error('Error fetching standards data:', error)
            }
        }
    }

    const handleUpdateClick = () => {
        setIsLoading(true);
        fetchTeacherOverview();
    }


    useEffect(() => {
        fetchTeacherOverview();
    }, [user.userContext])

    if (!user.userContext) {
        return <Loader message={'Fetching User Data'}/>
    } else if (!user.userContext.termsAccepted) {
        return <ToSModal user={user}/>
    } else if (user.userContext.role !== 'coordinator') {
        navigate('/')
    } else if (!teachingOverviewData || isLoading) {
        const loadingItems = [
            (!teachingOverviewData) && "Teaching Data",
        ].filter(Boolean); // Filter out false/null values

        const fetchingText = loadingItems.length > 1
            ? `Fetching: ${loadingItems.slice(0, -1).join(", ")} and ${loadingItems.slice(-1)}`
            : `Fetching: ${loadingItems[0] || ""}`;
        return <div className={'bg-burnt_sienna-700 mx-1 min-h-full py-20 rounded-b rounded-tr shadow'}>
            <LocalLoaderLight message={fetchingText}/>
        </div>
    } else {
        return (
            <>
                <div className={'bg-burnt_sienna-700 p-1 mx-1 rounded-tr rounded-b shadow'}>
                    <div className={'flex justify-between mx-20'}>
                        <div>
                            <p className={'select-none text-dutch_white-200'}>Start Date:</p>
                            <input className={'bg-dutch_white-100 rounded p-2'} type={"date"} value={startDate}
                                   onChange={(e) => setStartDate(e.target.value)}/>

                        </div>
                        <button className={'rounded bg-columbia_blue-500 hover:bg-columbia_blue-400 cursor-pointer h-fit p-2 my-auto'}
                                onClick={handleUpdateClick}>Update Data Summary
                        </button>
                        <div>
                            <p className={'select-none text-dutch_white-200'}>End Date:</p>
                            <input className={'bg-dutch_white-100 rounded p-2'} type={"date"} value={endDate}
                                   onChange={(e) => setEndDate(e.target.value)}/>

                        </div>
                    </div>

                    <div className={'grid grid-cols-2 gap-4 py-2 mx-1 min-h-screen rounded-tr'}>
                        {teachingOverviewData.sort((a, b) => a.lastName.localeCompare(b.lastName)).map(teacher => (
                            <TeacherSummaryCard data={teacher} startDate={startDate} endDate={endDate}/>
                        ))}

                    </div>
                </div>
            </>
        )
    }
}

export default TeachingSummary;